// ! This file was auto-generated by @rtk-query/codegen-openapi. Do not override this file.

import { api } from "~/redux/api/weaver/codegenApi";
const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        getComments: build.query<GetCommentsApiResponse, GetCommentsApiArg>({
            query: (queryArg) => ({
                url: `/${queryArg.entityType}/${queryArg.entityId}/comments`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createComment: build.mutation<CreateCommentApiResponse, CreateCommentApiArg>({
            query: (queryArg) => ({
                url: `/${queryArg.entityType}/${queryArg.entityId}/comments`,
                method: "POST",
                body: queryArg.commentRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateComment: build.mutation<UpdateCommentApiResponse, UpdateCommentApiArg>({
            query: (queryArg) => ({
                url: `/${queryArg.entityType}/${queryArg.entityId}/comments/${queryArg.commentId}`,
                method: "PATCH",
                body: queryArg.commentRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteComment: build.mutation<DeleteCommentApiResponse, DeleteCommentApiArg>({
            query: (queryArg) => ({
                url: `/${queryArg.entityType}/${queryArg.entityId}/comments/${queryArg.commentId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        resolveComment: build.mutation<ResolveCommentApiResponse, ResolveCommentApiArg>({
            query: (queryArg) => ({
                url: `/${queryArg.entityType}/${queryArg.entityId}/comments/${queryArg.commentId}/resolve`,
                method: "POST",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        unresolveComment: build.mutation<UnresolveCommentApiResponse, UnresolveCommentApiArg>({
            query: (queryArg) => ({
                url: `/${queryArg.entityType}/${queryArg.entityId}/comments/${queryArg.commentId}/unresolve`,
                method: "POST",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getCommentImportStatus: build.query<GetCommentImportStatusApiResponse, GetCommentImportStatusApiArg>({
            query: (queryArg) => ({
                url: `/document/${queryArg.documentId}/version/${queryArg.versionId}/comment-import-status/`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetCommentsApiResponse = 
/** status 200 Comments for the entity */ Comment[];
export type GetCommentsApiArg = {
    entityType: ContextEntityType;
    entityId: string;
};
export type CreateCommentApiResponse = 
/** status 200 Created comment */ Comment;
export type CreateCommentApiArg = {
    entityType: ContextEntityType;
    entityId: string;
    commentRequest: CommentRequest;
};
export type UpdateCommentApiResponse = 
/** status 200 Updated comment */ Comment;
export type UpdateCommentApiArg = {
    entityType: ContextEntityType;
    entityId: string;
    commentId: string;
    commentRequest: CommentRequest;
};
export type DeleteCommentApiResponse = void;
export type DeleteCommentApiArg = {
    entityType: ContextEntityType;
    entityId: string;
    commentId: string;
};
export type ResolveCommentApiResponse = void;
export type ResolveCommentApiArg = {
    entityType: ContextEntityType;
    entityId: string;
    commentId: string;
};
export type UnresolveCommentApiResponse = 
/** status 200 Comment unresolved */ void;
export type UnresolveCommentApiArg = {
    entityType: ContextEntityType;
    entityId: string;
    commentId: string;
};
export type GetCommentImportStatusApiResponse = 
/** status 200 Comment import status */ CommentImportStatus;
export type GetCommentImportStatusApiArg = {
    documentId: string;
    versionId: string;
};
export type ContentAst = {
    [key: string]: any;
}[];
export type ContextEntityType = "document" | "document_handler" | "document_version" | "highlight" | "editor_highlight" | "ticket" | "ticket_document_version" | "ticket_v2";
export type ContextEntity = {
    type: ContextEntityType;
    id: string;
};
export type MentionEntity = {
    type: "user" | "document" | "department";
    id: string | number;
};
export type CommentRequest = {
    version?: "v1";
    content: ContentAst;
    context?: ContextEntity[];
    threadId?: string | null;
    mentions?: MentionEntity[];
    entityId?: string;
    entityType?: ContextEntityType;
};
export type Comment = CommentRequest & {
    id: string;
    entityId: string;
    entityType: ContextEntityType;
    createdBy: number | null;
    creatorName?: string | null;
    createdDate: string;
    modifiedDate: string;
    isResolved: boolean;
    isDeleted: boolean;
};
export type ErrorResponse = {
    error?: string;
    errors?: string[];
    errorId?: string;
};
export type CommentImportStatus = {
    status: "FAILED" | "SUCCESSFUL" | "IN_PROGRESS";
    sfdtGeneratedAt: number;
};
